import { JSX } from 'react';
import {
    Create,
    SimpleForm,
    SelectInput,
    ReferenceInput,
    TextInput,
    required,
    BooleanInput,
    NumberInput
} from 'react-admin';
import {
    LinearProgress,
} from '@mui/material';
import { currency, frequency } from "../../defaults/defaults";
import { useGetSubscriptionTiers } from "../global-hooks/default-system-hooks";
import { ChatFieldBridge } from "../chat-bot/components/ChatFieldBridge";

export const SubscriptionProductCreate: () => JSX.Element = (): JSX.Element => {
    const { loadedSubscriptionTiers, loadingSubscriptionTiers } = useGetSubscriptionTiers();

    return (
        <Create>
            <SimpleForm >
                <TextInput source="name" validate={ [required()] } />
                <BooleanInput source="active" validate={ [required()] } />
                { (loadingSubscriptionTiers) &&
                    <LinearProgress sx={ { margin: '10px 0', width: '75%' } } />
                }
                { (!loadingSubscriptionTiers) &&
                    <SelectInput
                        name="tierLevel"
                        source="tierLevel"
                        optionValue="id"
                        choices={ loadedSubscriptionTiers }
                        validate={ [required()] }
                    />
                }
                <NumberInput source="product_price_price"
                             label="Price"
                             name="product_price_price" validate={ [required()] } />
                <SelectInput source="product_price_currency"
                             label="Currency"
                             name="product_price_currency"
                             choices={ currency }
                             validate={ [required()] } />
                <SelectInput source="product_price_frequency"
                             label="Subscription Frequency"
                             name="product_price_frequency"
                             choices={ frequency }
                             validate={ [required()] }
                             defaultValue="month" />
                <NumberInput source="product_price_frequency_count"
                             helperText="E.g. 1 month or 2 years"
                             name="product_price_frequency_count"
                             validate={ [required()] }
                             label="Subscription Frequency Count"
                             defaultValue={1} />
                <NumberInput source="monthlyCredits" validate={ [required()] }/>
                <NumberInput source="annualCredits" validate={ [required()] }/>
                {/* Offers this form to the assistant. Renders nothing, writes nothing by itself. */}
                <ChatFieldBridge />
            </SimpleForm>
        </Create>
    );
}
